import { render, staticRenderFns } from "./AnswerIcon.vue?vue&type=template&id=127277c6&"
import script from "./AnswerIcon.vue?vue&type=script&lang=js&"
export * from "./AnswerIcon.vue?vue&type=script&lang=js&"
import style0 from "./AnswerIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports